export type EventType =
    | 'viewed_bys_wizard_niche_cards'
    | 'viewed_bys_wizard_banner_choice'
    | 'viewed_bys_wizard_product_type'
    | 'viewed_bys_shopify_sign_up'
    | 'viewed_bys_access_shopify'
    | 'viewed_bys_install_app'
    | 'viewed_bys_subscribe_to_shopify'
    | 'viewed_bys_creating_shopify_store'
    | 'viewed_bys_autods_sign_up'
    | 'viewed_bys_make_customer_ready'
    | 'viewed_bys_publish_store'
    | 'viewed_bys_gigs_tab'
    | 'viewed_bys_gig_card';

export const PAGE_NAME = 'bys_wizard_funnel';
